import React from "react";

const personalInfoContent = [
  { meta: "first name", metaInfo: "AJESH BS" },
  { meta: "Age", metaInfo: "26 Years" },
  { meta: "Nationality", metaInfo: "India" },
  { meta: "Region", metaInfo: "Kerala" },
  { meta: "phone", metaInfo: "+916374223038" },
  { meta: "Email", metaInfo: "contact@ajeshbs.me" },
  { meta: "langages", metaInfo: "English" },
];

const PersonalInfo = () => {
  return (
    <ul className="about-list list-unstyled open-sans-font">
      {personalInfoContent.map((val, i) => (
        <li key={i}>
          <span className="title">{val.meta}: </span>
          <span className="value d-block d-sm-inline-block d-lg-block d-xl-inline-block">
            {val.metaInfo}
          </span>
        </li>
      ))}
    </ul>
  );
};

export default PersonalInfo;
